import styled from 'styled-components';
import { SliderLabelMixin } from '../../mixins/components/SliderLabelMixin';

/**
 * Used by the `Slider` component to label the slider thumb.
 *
 * @since 6.12.0
 */
var SliderLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "SliderLabel",
  componentId: "c11n-8-107-0__sc-jif7bv-0"
})(["", ""], SliderLabelMixin);
SliderLabel.displayName = 'SliderLabel';

/** @component */
export { SliderLabel };